<form [formGroup]="form" autocomplete="off" class="form-horizontal">

  <div class="form-row">
    <label class="col-sm-4 col-form-label"
           for="kontoinhaber{{index}}">{{ 'COMMON_UI.BANKVERBINDUNG.KONTOINHABER.LABEL' | translate }}
    </label>
    <div class="col-sm-8">
      <select (change)="onKontoinhaberChanged()" class="form-control" datevMessagePath="kontoinhaber{{objectId}}" formControlName="kontoinhaber"
              id="kontoinhaber{{index}}" utilsCheckValidity
              utilsControlState utilsMarkRequired
              utilsValidationMessage>
        <option [ngValue]="null" selected>{{ 'COMMON_UI.BANKVERBINDUNG.KONTOINHABER.NULL' | translate }}</option>
        <option *ngFor="let element of kontoinhaberOptions"
                [ngValue]="element.value">{{ element.label | translate }}
        </option>
      </select>
    </div>
  </div>

  <div *ngIf="this.data?.kontoinhaber === this.kontoinhaberEnum._99" class="form-row">
    <label class="col-sm-4 col-form-label"
           for="abweichenderKontoinhaber{{index}}">{{ 'COMMON_UI.BANKVERBINDUNG.ABWEICHENDER_KONTOINHABER' | translate }}</label>
    <div class="col-sm-8">
      <input class="form-control" datevMessagePath="abweichenderKontoinhaber{{objectId}}" formControlName="abweichenderKontoinhaber"
             id="abweichenderKontoinhaber{{index}}"
             type="text" utilsCheckValidity utilsControlState
             utilsMarkRequired utilsValidationMessage
      />
    </div>
  </div>

  <div *ngIf="data.kontoinhaber">
    <div class="form-row">
      <label class="col-sm-4 col-form-label"
             for="iban{{index}}">{{ 'COMMON_UI.BANKVERBINDUNG.IBAN' | translate }}</label>
      <div class="col-sm-8">
        <input [checkAdditionalControls]="['bic']" class="form-control" datevMessagePath="iban{{objectId}}" formControlName="iban"
               id="iban{{index}}" type="text" utilsCheckValidity utilsControlState
               utilsMarkRequired utilsValidationMessage/>
      </div>
    </div>

    <div *ngIf="isAuslaendischeIban() || (data.bic && !(data.iban?.length > 1))" class="form-row">
      <label class="col-sm-4 col-form-label"
             for="bic{{index}}">{{ 'COMMON_UI.BANKVERBINDUNG.BIC' | translate }}</label>
      <div class="col-sm-8">
        <input class="form-control" datevMessagePath="bic{{objectId}}" formControlName="bic" id="bic{{index}}"
               type="text" utilsCheckValidity utilsControlState
               utilsMarkRequired utilsValidationMessage/>
      </div>
    </div>
  </div>
</form>
